import { Tab, Tabs } from '@mui/material';
import { AppConfig } from 'AppConfig';
import { fetchData } from 'features/user/userActions';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Link, Outlet, useLocation } from 'react-router-dom';
import routePaths from 'routes/routePaths';
import { tabNoUnderlineSx, tabsNoUnderlineSx } from 'common/tabSx';
import { store } from 'store/store';
import { hasPermission } from 'utils/common';

const TenantManagementNavigator = () => {
  const TENANT_MANAGEMENT_URL = routePaths.tenantManagement;
  const TENANT_ACCESS_URL = `${TENANT_MANAGEMENT_URL}/${AppConfig.TENANT_MANAGEMENT_SUB_URL.TENANT}`;
  const BROKER_ACCESS_URL = `${TENANT_MANAGEMENT_URL}/${AppConfig.TENANT_MANAGEMENT_SUB_URL.BROKER}`;
  const MG_RENEWL_MGMT_ACCESS_URL = `${TENANT_MANAGEMENT_URL}/${AppConfig.TENANT_MANAGEMENT_SUB_URL.MD_RENEWAL_MGMT}`;
  const permissions = useSelector((state) => state.user.permissions);
  const location = useLocation();
  const { defaultUserState, currentTenantCd } = useSelector((state) => state.user);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (defaultUserState) {
        store.dispatch(fetchData(currentTenantCd, AppConfig.APP_CODE_FO, { explicitTenant: false }));
      }
    }, 100);
    return () => clearTimeout(timeout);
  }, []);

  return (
    <>
      <Tabs
        value={location.pathname}
        indicatorColor="primary"
        textColor="primary"
        sx={tabsNoUnderlineSx}>
        <Tab label="Tenant Management" value={TENANT_ACCESS_URL} component={Link} to={TENANT_ACCESS_URL} sx={tabNoUnderlineSx} />
        {hasPermission(AppConfig.PERMISSION.BROKER_MANAGEMENT, permissions) && <Tab label="Broker Management" value={BROKER_ACCESS_URL} component={Link} to={BROKER_ACCESS_URL} sx={tabNoUnderlineSx} />}
        <Tab label="MD Renewal Management" value={MG_RENEWL_MGMT_ACCESS_URL} component={Link} to={MG_RENEWL_MGMT_ACCESS_URL} sx={tabNoUnderlineSx} />
      </Tabs>
      <Outlet />
    </>
  );
};

export default TenantManagementNavigator;
